module.exports = __webpack_public_path__ + "img/map.74acc537.png";